import { Badge } from '@shared/components/ui/badge';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getMerchandiseStatusLabel, MerchandiseStatus } from '../models/Merchandise';

interface MerchandiseStatusBadgeProps {
  status: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const MerchandiseStatusBadge: React.FC<MerchandiseStatusBadgeProps> = ({
  status,
  className = '',
  size = 'sm',
}) => {
  const { t } = useTranslation('merchandise');

  const statusEnum = status as MerchandiseStatus;
  const label = getMerchandiseStatusLabel(statusEnum, t);

  // Mapear los colores a variantes de Badge
  let variant:
    | 'default'
    | 'secondary'
    | 'destructive'
    | 'outline'
    | 'transparent-blue'
    | 'transparent-orange'
    | 'transparent-green' = 'outline';

  switch (statusEnum) {
    case MerchandiseStatus.PENDING:
      variant = 'transparent-blue';
      break;
    case MerchandiseStatus.PARTIAL_RECEIVED:
      variant = 'transparent-orange';
      break;
    case MerchandiseStatus.RECEIVED:
      variant = 'transparent-green';
      break;
    case MerchandiseStatus.CANCELED:
      variant = 'transparent-green';
      break;
    case MerchandiseStatus.CLOSED:
      variant = 'outline';
      break;
  }

  // Clases base según el tamaño
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  const combinedClassName = `transition-colors font-regular ${sizeClasses[size]} ${className}`;

  return (
    <Badge variant={variant} className={combinedClassName} data-testid={`merchandise-status-badge-${statusEnum}`}>
      {label}
    </Badge>
  );
};

export default MerchandiseStatusBadge;
